<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <p class="letraColorAzulPrincipal letraEstiloNegrita">
      {{ data.item.nombrePaciente }}
    </p>
  </div>

</template>

<script>
export default {
    name: "NombrePacienteComponente",
    props: {
        data: Object,
        resource: Object
    },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
    methods: {
       
    }
}
</script>
